import '../../../stylesheets/nav/nav.css' 
import React from 'react';
import { Link } from 'react-router-dom'
import ProfilePopover from '../shared/ProfilePopover.js'

const Desktop = ( { currentPath, isActive, subscription, paymentMethod } ) => {

    return (
        <>

            {/* Feature Node Sibling 1 of 3 Inside NavBar Container */}
            <div className="desktop-navbar-brand">
                Pulse<br/>Rank<br/>Labs
            </div>

            {/* Feature Node Sibling 2 of 3 Inside NavBar Container */}
            <div className="desktop-navbar-nav">
                <div className="desktop-navbar-separator"></div>
                <div className="desktop-navbar-item">
                    <Link
                        to="/authguard/dashboards/public-comparables"
                        className={`desktop-navbar-link ${isActive('/authguard/dashboards/public-comparables') ? 'desktop-navbar-link-active' : ''}`}
                    >
                        Public<br/>Comparables
                    </Link>
                </div>
                <div className="desktop-navbar-separator"></div>
                <div className="desktop-navbar-item">
                    <Link
                        to="/authguard/dashboards/transaction-comps"
                        className={`desktop-navbar-link ${isActive('/authguard/dashboards/transaction-comps') ? 'desktop-navbar-link-active' : ''}`}
                    >
                        Transaction<br/>Comps
                    </Link>
                </div>
                <div className="desktop-navbar-separator"></div>
                <div className="desktop-navbar-item">
                    <Link
                        to="/authguard/dashboards/football-field"
                        className={`desktop-navbar-link ${isActive('/authguard/dashboards/football-field') ? 'desktop-navbar-link-active' : ''}`}
                    >
                        Football<br/>Field
                    </Link>
                </div>
                <div className="desktop-navbar-separator"></div>
                <div className="desktop-navbar-item">
                    <Link
                        to="/authguard/dashboards/leaderboard"
                        className={`desktop-navbar-link ${isActive('/authguard/dashboards/leaderboard') ? 'desktop-navbar-link-active' : ''}`}
                    >
                        Movers<br/>Leaderboard
                    </Link>
                </div>
                <div className="desktop-navbar-separator"></div>
            </div>

            {/* Feature Node Sibling 3 of 3 Inside NavBar Container */}
            <div className="desktop-navbar-profile">
                <ProfilePopover
                    subscription={subscription}
                    paymentMethod={paymentMethod}
                />
            </div>
        </>
    );
};

export default Desktop 
